export default __webpack_public_path__ + "static/1-768aa3805893a66016f027bdef445c96.png";